var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"v-md-editor-preview",style:({
    tabSize: _vm.tabSize,
    '-moz-tab-size': _vm.tabSize,
    '-o-tab-size': _vm.tabSize,
  }),on:{"click":_vm.handlePreviewClick}},[_c('div',{class:[_vm.themeConfig.previewClass],domProps:{"innerHTML":_vm._s(_vm.html)}})])}
var staticRenderFns = []

export { render, staticRenderFns }